import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UserModel } from './user.model';
import { AbstractService } from '../services/abstract.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends AbstractService<UserModel> {
  constructor(http: HttpClient) {
    super(http, '/users', UserModel);
  }
}
